/**
 * @file   src\mobile\components\Onboarding\UserType.js
 * @brief  This file is responsible for selecting user type while onboaring.
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import ConfettiColoredIcon from "../../../images/confetti-colored-icon.svg";
import {
  USER_INFO_KEY,
  USER_TYPE_AGENT,
  USER_TYPE_MEMBER,
} from "../../../../constants/common";
import {
  getLocalStorage,
  setBodyBackgroundGrey,
  setLocalStorage,
} from "../../../../helpers/common";
import UserTypeOptions from "../v2/UserTypeOptions";
import { userTypes } from "../../../../constants/v2/common";
import { saveUserType_Title } from "../../../../services/v2/signupService";
import { convertToNumber } from "../../../../helpers/validations";

const itemArray = [
    { heading: "Yes", userTypeId: USER_TYPE_AGENT },
    { heading: "No", userTypeId: USER_TYPE_MEMBER },
  ];

const UserType = (props) => {
  const { handleUserTypeSelection, userType, handleActivePage } = props;
  const userDetails = getLocalStorage(USER_INFO_KEY);

  useEffect(() => {
    setBodyBackgroundGrey();
  }, []);

  const saveUserTypeAndTitle = async (reqPayload) => {
    try {
      const response = await saveUserType_Title(reqPayload);
      if (!response || response.errorCode !== 0) {
        throw new Error("Failed to save user type and title");
      }
      return response;
    } catch (error) {
      throw error;
    }
  };

  const handleCardClick = async () => {
    try {
      const reqPayload = { userTypeId: userType };

      const res = await saveUserTypeAndTitle(reqPayload);
      userDetails.userInfo.userType = convertToNumber(userType);

      setLocalStorage(USER_INFO_KEY, userDetails);
      handleActivePage();
    } catch (error) {
      throw error;
    }
  };

  return (
    <div className="gitcha-main-wrapper pb-0 bg-grey-variant">
      <div className="content-wrapper pt-0 h-100">
        <div className="inner-layout-content-new h-100 ps-3 pe-3">
          <div className="signup-login-header get-agent-wrap clearfix">
            <div className="confetti-colored-icon mt-5 mx-auto">
              <img src={ConfettiColoredIcon} />
            </div>
            <h2 className="pt-2 pb-2 text-center">Let's create your profile!</h2>
            <p className="mb-3 text-center">
              We're here to help meet you and your real estate goals. Let's set up your profile.
            </p>
          </div>
          <div className="title-selection-wrap ">
            <p className="mb-3 text-start">
              Are you a licensed real estate agent or property manager? 
            </p>
            {itemArray.map((option, index) => {
              return (
                <UserTypeOptions
                  key={index}
                  icon={option?.icon}
                  heading={option.heading}
                  isActive={userType === option.userTypeId}
                  onClick={() => {
                    handleUserTypeSelection(option.userTypeId);
                  }}
                />
              );
            })}
          </div>

          <Button
            variant="primary"
            className="btn w-100 mb-4 btn-auth-mob"
            disabled={userType ? false : true}
            onClick={() => handleCardClick()}
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UserType;
